import { useEffect, useState } from 'react';

export const PreferredLanguageDropdown = ({ value, onChange }) =>
{
  const [lang, setLanguage] = useState(value);

  useEffect(() => {
    onChange?.(lang);
  }, [lang]);

  useEffect(() => {
    setLanguage(value);
  }, [value])

  return (
    <select className="f-lang" value={ lang }
            onChange={e=>setLanguage(e.target.value)}
            onBlur={e=>setLanguage(e.target.value)}>
      <option value="zh-HK">繁體中文</option>
      <option value="zh-CN">簡體中文</option>
      <option value="en-US">英文</option>
    </select>
  );
}

export default PreferredLanguageDropdown;